import {action, observable} from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

// 角色管理
export default class roleState extends baseState {
  // 列表
  @observable list = {};
  @action
  setList(data) {
    this.list = data;
  }
  getList = (data) => {
    return this.fetch({
      url: apiUrl.PERMISSION.ROLE.LIST,
      setState: this.setList,
      method: 'get',
      data
    });
  };
  // 详情
  @observable detail = {};
  @action
  setDetail(data) {
    this.detail = data;
  }
  getDetail = (id) => {
    return this.fetch({
      url: apiUrl.PERMISSION.ROLE.DETAIL + id,
      setState: this.setDetail,
      method: 'get',
    });
  };

  insert = data => {
    return this.fetch({
      url: apiUrl.PERMISSION.ROLE.INSERT,
      data,
    });
  };

  update = data => {
    return this.fetch({
      url: apiUrl.PERMISSION.ROLE.UPDATE,
      data,
    });
  };

  delete = (id) => {
    return this.fetch({
      url: apiUrl.PERMISSION.ROLE.DELETE + id,
    });
  };
  // 列表
  @observable menuList = [];
  @action
  setMenuList(data) {
    this.menuList = data || [];
  }
  getMenuList = (data) => {
    return this.fetch({
      url: apiUrl.PERMISSION.ROLE.MENU_LIST,
      setState: this.setMenuList,
      method: 'get',
      data
    });
  };

}
